<template>
  <v-flex
    xs8
    sm6
    :md="message.fromMe === 1 ? 4 : 5"
    :offset-xs4="message.fromMe === 1"
    :offset-sm6="message.fromMe === 1"
    :offset-md8="message.fromMe === 1"
    class="mb-1"
    :key="message.id"
    >
    <v-card
        :dark="message.fromMe === 1"
        class="shadow-2"
        :color="message.fromMe === 1 ? 'secondary' : ''"
    >
        <v-card-text class="pb-1">
        <template v-if="message.fromMe === 1">
            <p class="white--text text--body-2 mb-1">
            {{ message.body }}
            </p>
        </template>
        <template v-else>
            <v-list-item small>
            <v-list-item-content>
                <v-list-item-title>
                {{ message.body | getNameVCard }}
                </v-list-item-title>
                <v-list-item-subtitle>
                {{ message.body | getNumberVCard }}
                </v-list-item-subtitle>
            </v-list-item-content>
            </v-list-item>
        </template>

        <div>
            <span class="ml-n2">
            <v-icon
                v-if="message.ack >= 1"
                small
                :color="message.ack === 3 ? 'teal darken-1' : ''"
            >mdi-check</v-icon>
            <v-icon
                v-if="message.ack >= 2"
                small
                class="ml-n3"
                :color="message.ack === 3 ? 'teal darken-1' : ''"
            >mdi-check</v-icon>
            </span>
            <small>
            {{ message.created_at | getHour12Format }}
            </small>
        </div>
        </v-card-text>

        <v-avatar
        v-if="message.reaction"
        color="blue-grey darken-4"
        size="26"
        class="ml-1 mb-n3"
        >
        {{ message.reaction }}
        </v-avatar>
    </v-card>
    </v-flex>

</template>

<script>
import moment from "moment";

export default {
    props: {
        message: {
            type: Object,
        },
        NameClient: {
            type: String,
        },
    },

    filters: {
        getHour12Format(date) {
            const hour = moment(date).format("LT");
            return hour;
        },

        getNameVCard(VCARD) {
      // Expresión regular para extraer lo que está después de FN:
      const regex = /FN:(.*?)\n/;
      const match = VCARD.match(regex);
      const result = match[1];

      return result;
    },

    getNumberVCard(VCARD) {
      // Expresión regular para extraer lo que está después de FN:
      const regex = /waid=(.*?):/;
      const match = VCARD.match(regex);
      const result = match[1];

      return result;
    }
    }
}
</script>

<style>

</style>